// extracted by mini-css-extract-plugin
module.exports = {"tableAlert":"tableAlert-f08b1cb9"};